//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebsiteScriptCodeInputItem } from './WebsiteScriptCodeInputItem';
import { WebsitePageInputItem } from './WebsitePageInputItem';
import { WebsiteSocialLinksLocation, WebsiteTemplate, WebsiteHostingType } from './Enums';

export class WebsiteUpdateItem extends ItemBase {
    Url?: string | null;
    Title?: string | null;
    AccentColor?: string | null;
    BackgroundColor?: string | null;
    HeaderColor?: string | null;
    FooterColor?: string | null;
    HeadingFontFamily?: string | null;
    BodyFontFamily?: string | null;
    ScriptCodes?: WebsiteScriptCodeInputItem[];
    FacebookUrl?: string | null;
    TwitterUrl?: string | null;
    InstagramUrl?: string | null;
    LinkedInUrl?: string | null;
    YouTubeUrl?: string | null;
    TikTokUrl?: string | null;
    SocialLinksLocation?: WebsiteSocialLinksLocation;
    HeaderLogoMediaLibraryItemID?: string | null;
    Template?: WebsiteTemplate | null;
    HostingType?: WebsiteHostingType;
    WebsitePages?: WebsitePageInputItem[];

    constructor(initializer?: Partial<WebsiteUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsiteUpdateItem";
}
